import React from "react";

import { JobResponseEntity, SimilarJobItem } from "@/src/hooks/api/generated";

import { ToggleSaveJobClient } from "./ToggleSaveJobClient";

export interface IToggleSaveJob {
  jobDetails: SimilarJobItem | JobResponseEntity;
  isInFloating?: boolean;
  isCircle?: boolean;
  useLocalState?: boolean;
}

export default function ToggleSaveJob({
  jobDetails,
  isInFloating = false,
  isCircle = false,
  useLocalState = false,
}: IToggleSaveJob): JSX.Element {
  return (
    <ToggleSaveJobClient
      jobDetails={jobDetails}
      isInFloating={isInFloating}
      isCircle={isCircle}
      useLocalState={useLocalState}
    />
  );
}
